import React, { useEffect, useRef, useState } from "react";
import styles from "./CommerceTimeline.module.scss";

const CommerceTimeline: React.FC = () => {
  const itemsRef = useRef<HTMLLIElement[]>([]);
  const drawLineRef = useRef<HTMLSpanElement>(null);
  const greyLineRef = useRef<HTMLSpanElement>(null);
  const [isClient, setIsClient] = useState(false);

  const descriptions = [
    <p key="desc-1">
      Source data for <span>real-time competitive data analysis</span>
    </p>,
    <p key="desc-2">
      Harmonise product data for <span>visual insights</span>
    </p>,
    <p key="desc-3">
      Data <span>Classification</span> with adaptive ML models
    </p>,
    <p key="desc-4">
      <span> Global Trends</span> with Consumer data.
    </p>,
    <p key="desc-5">
      <span> Monitor Influencer Trends</span> with Social data.
    </p>,
    <p key="desc-6">
      <span> Anayze Traffic</span> from Multiple source and create actionable
      campaigns.
    </p>,
    <p key="desc-7">
      <span> Engage</span> and plan your assortments.
    </p>,
  ];

  useEffect(() => {
    // Only set this after the component has mounted on the client
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const handleScroll = () => {
      if (!drawLineRef.current || !greyLineRef.current) return;

      const redLineHeight = drawLineRef.current.offsetHeight;
      const greyLineHeight = greyLineRef.current.offsetHeight;
      const windowDistance = window.scrollY;
      const windowHeight = window.innerHeight / 2;
      const timelineDistance = (
        document.querySelector(`.${styles.timeline}`) as HTMLElement
      ).offsetTop;

      if (windowDistance >= timelineDistance - windowHeight) {
        let line = windowDistance - timelineDistance + windowHeight;

        if (line <= greyLineHeight) {
          drawLineRef.current.style.height = `${line + 20}px`;
        }
      }

      const bottom =
        drawLineRef.current.getBoundingClientRect().top + redLineHeight;
      itemsRef.current.forEach((item, index) => {
        if (bottom > item.getBoundingClientRect().top) {
          item.classList.add(styles.inView);
        } else {
          item.classList.remove(styles.inView);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isClient]);

  return (
    <div>
      <div className={styles.header}>
        <h1>Data Intelligence for eTail</h1>
      </div>
      <div className={styles.timeline}>
        <ul>
          <span className={styles.defaultLine} ref={greyLineRef}></span>
          <span className={styles.drawLine} ref={drawLineRef}></span>
          {descriptions.map((desc, index) => (
            <li
              key={index}
              ref={(el) => (itemsRef.current[index] = el!)}
              className={
                index >= 1
                  ? index % 2 === 0
                    ? styles.right
                    : styles.left
                  : styles.right
              }
            >
              <div className={styles.blueDot}></div>
              <div className={styles.blueDotDash}></div>
              <div className={styles.content}>{desc}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CommerceTimeline;
